module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_shop_reserve_white-87925c38719a0b85bfcfac908e9edc82.svg";